"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function LightModeFilledIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12.021,7.766a4.211,4.211,0,1,0,4.209,4.21A4.214,4.214,0,0,0,12.021,7.766Z" }),
        react_1.default.createElement("path", { d: "M19.7.024H4.3A4.279,4.279,0,0,0,.024,4.3V19.7A4.28,4.28,0,0,0,4.3,23.976H19.7A4.28,4.28,0,0,0,23.976,19.7V4.3A4.279,4.279,0,0,0,19.7.024ZM11.255,3.5h1.531V4.8H11.255ZM6.539,5.416l.919.92L6.376,7.418,5.457,6.5Zm-1.764,7.3h-1.3V11.188h1.3Zm1.7,5.8L5.389,17.435l.92-.92L7.391,17.6ZM12.69,20.5H11.16V19.2h1.53Zm-.669-2.782a5.74,5.74,0,1,1,5.74-5.74A5.747,5.747,0,0,1,12.021,17.716Zm5.44.868-.919-.92,1.082-1.082.919.92Zm.23-11.1L16.609,6.4l.92-.92,1.082,1.082Zm2.834,5.327h-1.3V11.283h1.3Z" })));
}
exports.default = LightModeFilledIcon;
